export const setDocumentTitle = (pageTitle) => {
	return document.title = pageTitle ? `${pageTitle} - Bezos Seller Portal` : "Bezos Seller Portal";
};
